<template>
  <div class="questionnaire">
    <edit-modal ref="editModal"></edit-modal>
    <group-edit-modal ref="widgetEditModal"></group-edit-modal>
    <section-modal ref="sectionModal"></section-modal>
    <upload-tooltips-modal ref="uploadModal"></upload-tooltips-modal>
    <field-group-modal ref="fieldGroupModal"></field-group-modal>
    <checkbox-group-modal ref="checkboxGroupModal"></checkbox-group-modal>
    <inline-help-modal ref="inlineHelpModal"></inline-help-modal>
    <restore-inline-help-modal ref="restoreInlineHelpModal"></restore-inline-help-modal>
    <field-group-edit-modal></field-group-edit-modal>
    <checkbox-group-edit-modal></checkbox-group-edit-modal>
    <section-edit-modal></section-edit-modal>
    <widget-labels-modal
      v-if="showWidgetLabelsModal === true"
      @close="showWidgetLabelsModal = false"
    />
    <global-modal
      v-if="showQuestionnairePreviewModal === true"
      @close="showQuestionnairePreviewModal = false"
      :width="90"
    >
      <template slot="header">

        <b style="margin-left:-15px;">Questionnaire Preview</b>
        <i class="fas fa-times pull-right" style="cursor:pointer;" @click="showQuestionnairePreviewModal = false"></i>

      </template>

      <template slot="body">
        <div style="height:700px;overflow-y:auto;overflow-x:hidden">
          <pf-questionnaire-form
            v-if="formattedData !== null"
            :data="Object.values(formattedData)"
            :forms="[{}]"
          />
        </div>

      </template>

      <template slot="footer">

        <div style="margin-bottom:10px;">
          <button
            class="btn btn-secondary"
            @click="showQuestionnairePreviewModal = false"
          >
            Close
          </button>
        </div>

      </template>
    </global-modal>

    <div class="bar-icons">
      <div class="icons-individual">
        <button id="iconRemove" @mouseout="tooltipRemove = false" @mouseover="tooltipRemove = true" :disabled="noRows" class="btn btn-default mybutton" @click="removeAll">
          <!-- Remove All -->
          <i class="fas fa-trash-alt"></i>
        </button>
        <tooltip-icons v-if="tooltipRemove == true"
          :descriptionIcons="descriptionRemove"
          :left="leftIconRemove"
        />
      </div>

      <div class="icons-individual">
        <button id="iconUploadTooltips" @mouseout="tooltipUploadTooltips = false" @mouseover="tooltipUploadTooltips = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="showUploadTooltips">
          <!-- Upload Tooltips -->
          <i class="fas fa-upload"></i>
        </button>
        <tooltip-icons v-if="tooltipUploadTooltips == true"
          :descriptionIcons="descriptionUploadTooltips"
          :left="leftIconUploadTooltips"
        />
      </div>

      <div class="icons-individual">
        <button id="iconGenerateFields" @mouseout="tooltipGenerateFields = false" @mouseover="tooltipGenerateFields = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="generateFields">
          <!-- Generate From Fields -->
          <i class="far fa-file-alt"></i>
        </button>
        <tooltip-icons v-if="tooltipGenerateFields == true"
          :descriptionIcons="descriptionGenerateFields"
          :left="leftIconGenerateFields"
        />
      </div>

      <div class="icons-individual">
        <button id="iconParseInlineHelp" @mouseout="tooltipParseInlineHelp = false" @mouseover="tooltipParseInlineHelp = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="generateAllInlineHelp">
          <!-- Parse all Inline Help -->
          <i class="fas fa-cut"></i>
        </button>
        <tooltip-icons v-if="tooltipParseInlineHelp == true"
          :descriptionIcons="descriptionParseInlineHelp"
          :left="leftIconParseInlineHelp"
        />
      </div>

      <div class="icons-individual">
        <button id="iconRestoreInlineHelp" @mouseout="tooltipRestoreInlineHelp = false" @mouseover="tooltipRestoreInlineHelp = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="restoreAllInlineHelp">
          <!-- Restore all Inline Help -->
          <i class="fas fa-window-restore"></i>
        </button>
        <tooltip-icons v-if="tooltipRestoreInlineHelp == true"
          :descriptionIcons="descriptionRestoreInlineHelp"
          :left="leftIconRestoreInlineHelp"
        />
      </div>

      <div class="icons-individual">
        <button id="iconFieldGroups" @mouseout="tooltipFieldGroups = false" @mouseover="tooltipFieldGroups = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="showFieldGroupModal">
          <!-- Field Groups -->
          <i class="fas fa-object-group"></i>
        </button>
        <tooltip-icons v-if="tooltipFieldGroups == true"
          :descriptionIcons="descriptionFieldGroups"
          :left="leftIconFieldGroups"
        />
      </div>

      <div class="icons-individual">
        <button id="iconCheckboxGroups" @mouseout="tooltipCheckboxGroups = false" @mouseover="tooltipCheckboxGroups = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="showCheckboxGroupModal">
          <!-- Checkbox Groups -->
          <i class="far fa-object-group"></i>
        </button>
        <tooltip-icons v-if="tooltipCheckboxGroups == true"
          :descriptionIcons="descriptionCheckboxGroups"
          :left="leftIconCheckboxGroups"
        />
      </div>

      <div class="icons-individual">
        <button id="iconAddSection" @mouseout="tooltipAddSection = false" @mouseover="tooltipAddSection = true" class="btn btn-default mybutton" :disabled="$store.state.currentTemplateName === 'global'" @click="showSectionModal">
          <!-- Add Section -->
          <i class="fas fa-plus"></i>
        </button>
        <tooltip-icons v-if="tooltipAddSection == true"
          :descriptionIcons="descriptionAddSection"
          :left="leftIconAddSection"
        />
      </div>

      <div class="icons-individual">
        <button
          id="iconWidgetLabels"
          @mouseout="tooltipWidgetLabels = false"
          @mouseover="tooltipWidgetLabels = true"
          class="btn btn-default mybutton"
          :disabled="$store.state.currentTemplateName === 'global'"
          @click="showWidgetLabelsModal = true">
          <!-- Widget Labels -->
          <i class="fas fa-file-word"></i>
        </button>
        <tooltip-icons v-if="tooltipWidgetLabels == true"
          :descriptionIcons="descriptionWidgetLabels"
          :left="leftIconWidgetLabels"
        />
      </div>

      <div class="icons-individual">
        <button
          id="iconQuestionnairePreview"
          @mouseout="tooltipQuestionnairePreview = false"
          @mouseover="tooltipQuestionnairePreview = true"
          class="btn btn-default mybutton"
          :disabled="$store.state.currentTemplateName === 'global'"
          @click="showQuestionnairePreviewModal = true">
          <!-- Widget Labels -->
          <i class="fas fa-eye"></i>
        </button>
        <tooltip-icons v-if="tooltipQuestionnairePreview == true"
          :descriptionIcons="descriptionQuestionnairePreview"
          :left="leftIconQuestionnairePreview"
        />
      </div>
    </div>

    <div id="questionnaireBody">
      <div v-show="isSpinner === true">
        <center>
          <f-spinner/>
          <span>Loading ...</span>
        </center>
      </div>

      <div v-show="formattedData !== null && this.loading && !Object.keys(formattedData).length && isSpinner === false">
        <center><h1 style="margin-top:300px;">No Questions.</h1></center>
      </div>

      <!-- <h1 v-if="Object.keys(formattedData).length">Model Fields</h1> -->
      <template v-for="(field, fieldKey) in formattedData">
        <section
          v-if="field !== null && field.render !== false"
          :key="fieldKey"
        >
          <div class="widget-row group-box" v-if="field.type === 'grid'" :key="fieldKey">
            <widget-group :key="fieldKey"
            :fieldModel="field.model"
            :fieldIndex="fieldKey.toString()"
            :fieldName="field.fieldName"
            :templateObject="field">
            </widget-group>
            <div class="widget-sort" :key="fieldKey + Math.random(1024)">
              <i class="fas fa-eye" @click="editWidget(fieldKey)"></i>
              <i class="fas fa-arrow-circle-up" @click="move(fieldKey, true, true)"></i>
              <i class="fas fa-arrow-circle-down" @click="move(fieldKey, false, true)"></i>
            </div>
          </div>

          <div
            :id="fieldKey + 'widget'"
            :class="field.indent === 1 || field.indent === '1' ? 'indent-level1' : field.indent === 2 || field.indent === '2' ? 'indent-level2' : field.indent === 3 || field.indent === '3' ? 'indent-level3' : ''"
            class="widget-row single-widget" style="background-color: rgb(232, 232, 232);"
            v-else-if="field.type === 'checkbox-group'"
            :key="fieldKey">
            <div v-if="field.checkboxes && Object.keys(field.checkboxes).length === 2 && field.checkboxes[Object.keys(field.checkboxes)[0]].type === 'checkbox' && field.checkboxes[Object.keys(field.checkboxes)[1]].type === 'checkbox'">
              <div class="float-right">
                <label :for="'ABQuestion' + fieldKey" style="cursor: pointer;">
                  <input @change="setABQuestion({
                    field,
                    checkboxId: 'ABQuestion' + fieldKey
                  })" :checked="field.abQuestion" style="cursor: pointer;" type="checkbox" :id="'ABQuestion' + fieldKey"> A/B Question</label>
              </div>
              <br>
              <br>
            </div>

            <h3 class="widget-label">{{ field.title }}</h3>
            <h5 class="input-subtext">{{ field.desc }}</h5>
              <field-group-widget v-if="field.type === 'checkbox-group'"
                :ref="fieldKey"
                :key="fieldKey"
                :fieldIndex="fieldKey.toString()"
                :fieldName="field.fieldName"
                :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                :checkboxes="field.checkboxes"
                :maxChecked="field.maxChecked"
                :options="field.values"
                :editable="field.editable"
                :readOnly=true
                :model="field.model">
              </field-group-widget>
              <div class="widget-label" v-if="field.type !== 'section' && field.type !== 'checkbox-group'">Page: {{ field.page }}</div>
              <div class="widget-label" v-if="field.type !== 'section' && field.type !== 'checkbox-group'">Tab order: {{ field.tabOrder }}</div>
              <div class="widget-sort" :key="fieldKey + Math.random(1024)">
                <i class="fas fa-angle-double-left" @click="setFieldPage({fields: field.checkboxes, type: field.type})"></i>
                <!-- <i class="fas fa-pencil" v-if="field.type === 'checkbox-group'" @click="editGroup(field.fieldName)"></i> -->
                <i class="fas fa-eye" v-if="field.type === 'checkbox-group'" @click="editGroup(field.fieldName)"></i>
                <i class="fas fa-arrow-circle-up" @click="move(fieldKey, true)"></i>
                <i class="fas fa-arrow-circle-down" @click="move(fieldKey, false)"></i>
                <i class="fas fa-trash" v-if="field.type === 'checkbox-group'" @click="deleteGroup(field.fieldName)"></i>
              </div>

              <div style="margin-top: 20px;" class="font14">
                <i @click="setIndentationGroup({
                  indentation: false,
                  containerId: fieldKey + 'widget',
                  field
                })" style="margin-right: 20px;cursor:pointer;" class="fas fa-chevron-left fa-lg"></i>
                <i @click="setIndentationGroup({
                  indentation: true,
                  containerId: fieldKey + 'widget',
                  field
                })" style="cursor:pointer;" class="fas fa-chevron-right fa-lg"></i>
              </div>
          </div>

          <template v-else-if="field.model === '' || field.forceShow === true">
            <div :id="fieldKey + 'widget'" :class="field.indent === 1 ? 'indent-level1' : field.indent === 2 ? 'indent-level2' : field.indent === 3 ? 'indent-level3' : ''" class="widget-row single-widget" :key="fieldKey">
              <span class="widget-label" v-if="field.type !== 'section'">{{ field.title }}</span>
              <div class="input-subtext" v-if="field.type !== 'section'">{{ field.desc }}</div>
              <section-widget v-if="field.type === 'section'"
                :ref="fieldKey"
                :key="fieldKey"
                :fieldIndex="fieldKey.toString()"
                :fieldName="field.fieldName"
                :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                :subSection="field.subSection"
                :model="field.model"
                :inlineHelp="field.desc">
              </section-widget>
              <combo-widget v-if="field.type === 'combobox'"
                :ref="fieldKey"
                :key="fieldKey"
                :fieldIndex="fieldKey.toString()"
                :fieldName="field.fieldName"
                :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                :options="typeof field.values === 'array' ? field.values : []"
                :editable="field.editable"
                :readOnly=true
                :model="field.model">
                </combo-widget>
              <text-widget v-else-if="field.type === 'text'"
                :ref="fieldKey"
                :key="fieldKey"
                :fieldIndex="fieldKey.toString()"
                :fieldName="field.fieldName"
                :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                :editable="field.editable"
                :readOnly=true
                :model="field.model">
                </text-widget>
              <checkbox-widget v-else-if="field.type === 'checkbox'"
                :ref="fieldKey"
                :key="fieldKey"
                :fieldIndex="fieldKey.toString()"
                :fieldName="field.fieldName"
                :initialValue="field.newValue.length ? field.newValue : field.originalValue"
                :editable="field.editable"
                :readOnly=true
                :model="field.model">
                </checkbox-widget>
                <div class="widget-label" v-if="field.type !== 'section' && field.type !== 'checkbox-group'"><p style="margin-top:15px;" class="mb-0">Page: {{ field.page }}</p></div>
                <div class="widget-label mb-0" v-if="field.type !== 'section' && field.type !== 'checkbox-group'"><p class="mb-0">Tab order: {{ field.tabOrder }}</p></div>
                <div class="widget-sort" :key="fieldKey + Math.random(1024)">
                  <i class="fas fa-angle-double-left" v-if="field.type !== 'section' && field.type !== 'checkbox-group'" @click="setFieldPage({name: field.fieldName, type: field.type})"></i>
                  <i class="fas fa-pencil" v-if="field.type === 'checkbox-group'" @click="editGroup(field.fieldName)"></i>
                  <i class="fas fa-pencil" v-else-if="field.type === 'section'" @click="editSection({ key: fieldKey, section: field.originalValue, subSection: field.subSection })"></i>
                  <i class="fas fa-eye" v-else @click="editField(fieldKey)"></i>
                  <i class="fas fa-eye" v-if="field.type === 'section'" @click="editSection(fieldKey)"></i>
                  <i class="fas fa-trash" v-if="field.type === 'checkbox-group'" @click="deleteGroup(field.fieldName)"></i>
                  <i class="fas fa-arrow-circle-up" @click="move(fieldKey, true)"></i>
                  <i class="fas fa-arrow-circle-down" @click="move(fieldKey, false)"></i>
                  <i class="fas fa-trash" v-if="field.type === 'section' && field.type !== 'checkbox-group'" @click="deleteSection(field.fieldName)"></i>
                  <i class="fas fa-trash" v-if="field.type !== 'section' && field.type !== 'checkbox-group'" @click="deleteField(field.fieldName)"></i>
                </div>
                <button class="classic btn btn-light" v-if="field.type !== 'section' && field.type !== 'checkbox-group'" @click="showQuestionHelp(field.fieldName, field.desc, fieldKey)">Parse Inline Help</button>
                <button class="classic btn btn-light" v-if="field.type !== 'section' && field.type !== 'checkbox-group'" @click="restoreInlineHelp(field.fieldName, fieldKey)">Restore Inline Help</button>

                <!-- Indentation -->

                <div style="margin-top: 20px;" class="font14">
                  <i @click="setIndentation({
                    indentation: false,
                    containerId: fieldKey + 'widget',
                    field
                  })" style="margin-right: 20px;cursor:pointer;" class="fas fa-chevron-left fa-lg"></i>
                  <i @click="setIndentation({
                    indentation: true,
                    containerId: fieldKey + 'widget',
                    field
                  })" style="cursor:pointer;" class="fas fa-chevron-right fa-lg"></i>
                </div>
            </div>
          </template>
        </section>
      </template>
    </div>
  </div>
</template>

<script>
import ComboWidget from '@/components/questionnaires/widgets/ComboWidget'
import TextWidget from '@/components/questionnaires/widgets/TextWidget'
import CheckboxWidget from '@/components/questionnaires/widgets/CheckboxWidget'
import SectionWidget from '@/components/questionnaires/widgets/SectionWidget'
import FieldGroupWidget from '@/components/questionnaires/widgets/FieldGroupWidget'
import FieldGroupModal from '@/components/questionnaires/FieldGroupModal'
import CheckboxGroupModal from '@/components/questionnaires/CheckboxGroupModal'
import FieldGroupEditModal from '@/components/questionnaires/FieldGroupEditModal'
import CheckboxGroupEditModal from '@/components/questionnaires/CheckboxGroupEditModal'
import SectionEditModal from '@/components/questionnaires/SectionEditModal'
import EditModal from '@/components/questionnaires/EditModal'
import GroupEditModal from '@/components/questionnaires/widget-group/GroupEditModal'
import SectionModal from '@/components/questionnaires/SectionModal'
import UploadTooltipsModal from '@/components/questionnaires/UploadTooltipsModal'
import WidgetGroup from '@/components/questionnaires/widget-group/WidgetGroup'
import InlineHelpModal from '@/components/questionnaires/InlineHelpModal'
import RestoreInlineHelpModal from '@/components/questionnaires/RestoreInlineHelpModal'
import TooltipIcons from '@/components/editor/main/TooltipIcons'
import WidgetLabelsModal from '@/components/questionnaires/WidgetLabelsModal'
import GlobalModal from '@/components/editor/modals/GlobalModal'
import { PfQuestionnaireForm } from '@brevortriverstudios/vue-core'

import FSpinner from '@/components/questionnaires/Spinner.vue'

export default {
  name: 'questionnaire-view',

  components: {
    ComboWidget,
    TextWidget,
    CheckboxWidget,
    SectionWidget,
    FieldGroupModal,
    CheckboxGroupModal,
    FieldGroupEditModal,
    CheckboxGroupEditModal,
    SectionEditModal,
    FieldGroupWidget,
    WidgetGroup,
    EditModal,
    GroupEditModal,
    SectionModal,
    UploadTooltipsModal,
    InlineHelpModal,
    RestoreInlineHelpModal,
    TooltipIcons,
    WidgetLabelsModal,
    GlobalModal,
    PfQuestionnaireForm,

    FSpinner
  },

  data () {
    return {
      modelDisplay: false,
      idDisplay: false,
      lastHighlightedModel: '',
      formattedData: null,
      noRows: true,
      visibleWidgets: [],
      loading: true,
      tooltipRemove: false,
      descriptionRemove: 'Remove All Questionnaire',
      leftIconRemove: 0,
      tooltipUploadTooltips: false,
      descriptionUploadTooltips: 'Upload Tooltips',
      leftIconUploadTooltips: 0,
      tooltipGenerateFields: false,
      descriptionGenerateFields: 'Generate From Fields',
      leftIconGenerateFields: 0,
      tooltipParseInlineHelp: false,
      descriptionParseInlineHelp: 'Parse all Inline Help',
      leftIconParseInlineHelp: 0,
      tooltipRestoreInlineHelp: false,
      descriptionRestoreInlineHelp: 'Restore all Inline Help',
      leftIconRestoreInlineHelp: 0,
      tooltipFieldGroups: false,
      descriptionFieldGroups: 'Field Groups',
      leftIconFieldGroups: 0,
      tooltipCheckboxGroups: false,
      descriptionCheckboxGroups: 'Checkbox Groups',
      leftIconCheckboxGroups: 0,
      tooltipAddSection: false,
      descriptionAddSection: 'Add Section',
      leftIconAddSection: 0,
      tooltipWidgetLabels: false,
      descriptionWidgetLabels: 'Widget Labels',
      leftIconWidgetLabels: 0,
      tooltipQuestionnairePreview: false,
      descriptionQuestionnairePreview: 'Questionnaire Preview',
      leftIconQuestionnairePreview: 0,

      showWidgetLabelsModal: false,
      showQuestionnairePreviewModal: false,

      isSpinner: true
    }
  },

  mounted () {
    this.leftIconRemove = document.getElementById('iconRemove').offsetLeft
    this.leftIconUploadTooltips = document.getElementById('iconUploadTooltips').offsetLeft
    this.leftIconGenerateFields = document.getElementById('iconGenerateFields').offsetLeft
    this.leftIconParseInlineHelp = document.getElementById('iconParseInlineHelp').offsetLeft
    this.leftIconRestoreInlineHelp = document.getElementById('iconRestoreInlineHelp').offsetLeft
    this.leftIconFieldGroups = document.getElementById('iconFieldGroups').offsetLeft
    this.leftIconCheckboxGroups = document.getElementById('iconCheckboxGroups').offsetLeft
    this.leftIconAddSection = document.getElementById('iconAddSection').offsetLeft
    this.leftIconWidgetLabels = document.getElementById('iconWidgetLabels').offsetLeft
    this.leftIconQuestionnairePreview = document.getElementById('iconQuestionnairePreview').offsetLeft

    let that = this
    this.$on('widgetChanged', data => {
      that.widgetChanged(data)
    })

    this.$on('saveEdit', data => {
      that.saveEdit(data)
    })

    this.$bus.on('scrollToElement', that.scrollToElement)

    this.$bus.on('setCurrentTemplateName', templateName => {
      that.templateChanged(templateName)
    })

    // INIT PROCESS QUESTIONNAIRE

    this.$bus.on('reloadQuestionnaire', () => {
      that.templateChanged(this.$store.state.currentTemplateName)
    })

    this.$bus.on('updateQuestionnaire', () => {
      that.updateQuestionnaire()
    })

    this.$bus.on('setOnlyFieldGroup', (newGroupId) => {
      that.setOnlyFieldGroup(newGroupId)
    })

    this.$bus.on('initialUpdate', () => {
      that.initialUpdate()
    })

    this.$bus.on('setFieldPage', (dataField) => {
      that.setFieldPage(dataField)
    })

    this.$bus.on('pageChange', () => {
      that.modelDisplay = false
      that.idDisplay = false
      that.$bus.emit('toggleModelDisplay', that.modelDisplay)
    })

    this.$bus.on('removeSection', (sectionName) => {
      that.deleteSection(sectionName)
    })

    setTimeout(this.noDataFound, 7000)
  },

  methods: {
    setABQuestion (payload) {
      let checked = document.getElementById(payload.checkboxId).checked

      this.$store.commit('editFieldGroup', {
        index: payload.field.fieldName,
        name: payload.field.name,
        label: payload.field.title,
        help: payload.field.desc,
        abQuestion: checked
      })

      this.$bus.emit('saveTriggered')
    },

    setIndentationGroup (payload) {
      this.setClassIndent(payload)

      this.$store.commit('editFieldGroup', {
        index: payload.field.fieldName,
        name: payload.field.name,
        label: payload.field.title,
        help: payload.field.desc,
        indent: payload.field.indent
      })

      this.$bus.emit('saveTriggered')
    },

    setIndentation (payload) {
      this.setClassIndent(payload)

      this.$bus.emit('saveTriggered')
    },

    setClassIndent (payload) {
      let el = document.getElementById(payload.containerId)

      let arrayClass = []

      el.classList.forEach(classEl => {
        arrayClass.push(classEl)
      })

      if (arrayClass.indexOf('indent-level3') !== -1) {
        el.classList.remove('indent-level3')
        payload.field.indent = 0
        if (payload.indentation === false) {
          payload.field.indent = 2
          el.classList.add('indent-level2')
        }
      } else if (arrayClass.indexOf('indent-level2') !== -1) {
        el.classList.remove('indent-level2')
        if (payload.indentation === true) {
          payload.field.indent = 3
          el.classList.add('indent-level3')
        } else {
          payload.field.indent = 1
          el.classList.add('indent-level1')
        }
      } else if (arrayClass.indexOf('indent-level1') !== -1) {
        payload.field.indent = 0
        el.classList.remove('indent-level1')
        if (payload.indentation === true) {
          payload.field.indent = 2
          el.classList.add('indent-level2')
        }
      } else {
        if (payload.indentation === true) {
          payload.field.indent = 1
          el.classList.add('indent-level1')
        } else {
          payload.field.indent = 3
          el.classList.add('indent-level3')
        }
      }
    },

    setMessageWidget (foundWidget) {
      this.$store.commit('setMessageWidgetData', foundWidget)
    },

    restoreAllInlineHelp () {
      window.swal({
        title: 'Restore All Inline Help?',
        text: 'You are about to restore those fields inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((restore) => {
        let that = this
        if (restore) {
          this.$refs.restoreInlineHelpModal.$emit('showRestoreInlineHelp')
          this.$bus.emit('showProcessInlineHelp', {
            state: true,
            process: 'Restore Processing...'
          })
          setTimeout(function () {
            Object.keys(that.formattedData).forEach(field => {
              let questionnaireFields = that.$store.state.questionnaires[that.$store.state.currentTemplateName]['data']
              if (questionnaireFields[field] === undefined) return
              let fieldName = ''
              let fieldKey = field
              if (questionnaireFields[field].checkboxes) {
                Object.keys(questionnaireFields[field].checkboxes).forEach(name => {
                  fieldName = name
                  that.generateOriginInlineHelp(fieldName, fieldKey).then(() => {
                    return
                  })
                })
              } else {
                fieldName = questionnaireFields[field].fieldName
                that.generateOriginInlineHelp(fieldName, fieldKey).then(() => {
                  return
                })
              }
            })
            that.$store.dispatch('saveTemplate')
            that.$bus.emit('reloadQuestionnaire')
            that.$bus.emit('showProcessInlineHelp', {
              state: false,
              process: 'Done'
            })
          }, 500)
        }
      })
    },

    restoreInlineHelp (fieldName, fieldKey) {
      window.swal({
        title: 'Restore Inline Help?',
        text: 'You are about to restore this field inline help. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((restore) => {
        if (restore) {
          this.generateOriginInlineHelp(fieldName, fieldKey).then(() => {
            this.$bus.emit('reloadQuestionnaire')
          })
        }
      })
    },

    generateOriginInlineHelp (fieldName, fieldKey) {
      return new Promise((resolve, reject) => {
        let dataInlineHelp = this.$store.getters.getInlineHelpFromTemplate(fieldName)
        if (dataInlineHelp === null) {
          resolve(false)
        } else {
          this.$store.commit('changeInlineHelp', {
            questionnaireId: fieldKey,
            name: fieldName,
            label: dataInlineHelp.label,
            inlineHelp: dataInlineHelp.text
          })
          resolve(true)
        }
      })
    },

    generateAllInlineHelp () {
      let allDataInlineHelp = this.$store.getters.getAllQuestionnaireFileds()
      this.$refs.inlineHelpModal.$emit('showInlineHelp')
      this.$bus.emit('sendInlineHelp', allDataInlineHelp)
    },

    showQuestionHelp (fieldName, desc, fieldKey) {
      this.$refs.inlineHelpModal.$emit('showInlineHelp')
      this.$bus.emit('sendInlineHelp', {
        questionnaireId: fieldKey,
        name: fieldName,
        text: desc,
        one: true
      })
    },

    showUploadTooltips () {
      this.$refs.uploadModal.$emit('showUploadModal')
    },

    showFieldGroupModal () {
      this.$refs.fieldGroupModal.$emit('showModal')
    },

    showCheckboxGroupModal () {
      this.$refs.checkboxGroupModal.$emit('showModal')
    },

    showSectionModal () {
      this.$refs.sectionModal.$emit('showModal')
    },

    // VERIFY IF THERE IS QUESTIONNAIRE INFO LOAD AND CHANGE KEY ID FOR EACH FIELD

    templateChanged (templateName) {
      let newData = {}
      if (typeof this.$store.state.questionnaires[templateName] !== 'undefined') {
        newData = JSON.parse(JSON.stringify(this.$store.state.questionnaires[templateName].data))
      }
      let objFields = {}
      Object.keys(newData).forEach((fieldId, index) => {
        objFields[index + '-' + Math.random().toString(36).split('.')[1]] = newData[fieldId]
      })
      this.setupData(objFields)
    },

    // SET LOCAL INFO ONLY FOR FIELD GROUPS

    setOnlyFieldGroup (newGroupId) {
      let newData = this.$store.state.questionnaires[this.$store.state.currentTemplateName].data
      let groupFields = []
      let newGroup = null
      let dataGroups = []
      let positionFieldGroup = null
      let pageFieldGroup = null
      let tabsOrderModel = []
      let tabsOrderId = []

      if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return
      let fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']
      if (fieldGroup !== null && typeof fieldGroup !== 'undefined' && Object.keys(fieldGroup).length) {
        for (const key in this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']) {
          newGroup = {}

          if (this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            if (key === newGroupId) {
              const fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][key]

              if (fieldGroup.hide !== true) {
                let groupModel = ''
                let dataFieldGroupFields = {}
                Object.keys(fieldGroup.fields).forEach(field => {
                  groupFields.push(field)
                  let dataField = this.$store.getters.getTemplateData(field)
                  if (dataField.model !== '') tabsOrderModel.push(dataField.tabOrder)
                  else tabsOrderId.push(dataField.tabOrder)

                  if (fieldGroup.fields[field].tabOrder === undefined || fieldGroup.fields[field].tabOrder === null) {
                    let objetoFieldGroupField = {
                      label: dataField.translations.en.label,
                      desc: dataField.translations.en.text,
                      tabOrder: dataField.tabOrder
                    }
                    fieldGroup.fields[field] = objetoFieldGroupField
                  }
                  dataFieldGroupFields[field] = fieldGroup.fields[field]
                })

                let fieldGroupFields = this.$store.getters.orderFieldGroupFields(dataFieldGroupFields)
                if (tabsOrderModel.length > 0) {
                  positionFieldGroup = Math.min.apply(null, tabsOrderModel)
                  Object.keys(fieldGroup.fields).forEach(field => {
                    let dataField = this.$store.getters.getTemplateData(field)
                    if (positionFieldGroup === dataField.tabOrder) {
                      pageFieldGroup = dataField.fieldPage
                      groupModel = dataField.model
                    }
                  })
                } else {
                  positionFieldGroup = Math.min.apply(null, tabsOrderId)
                  Object.keys(fieldGroup.fields).forEach(field => {
                    let dataField = this.$store.getters.getTemplateData(field)
                    if (positionFieldGroup === dataField.tabOrder) {
                      pageFieldGroup = dataField.fieldPage
                      groupModel = dataField.model
                    }
                  })
                }

                newGroup = {
                  type: 'checkbox-group',
                  fieldName: key,
                  state: 'OK',
                  originalValue: '',
                  newValue: '',
                  itemId: 23,
                  model: groupModel,
                  deleted: false,
                  approved: true,
                  editable: true,
                  values: [],
                  fieldAdd: fieldGroup.fieldAdd,
                  name: fieldGroup.name,
                  title: fieldGroup.title,
                  desc: fieldGroup.desc,
                  checkboxes: fieldGroupFields,
                  checked: fieldGroup.checked,
                  maxChecked: this.$store.getters.fieldGroupMaxFields(fieldGroup.fieldId),
                  tabOrder: positionFieldGroup,
                  page: pageFieldGroup,
                  indent: fieldGroup.indent,
                  tags: fieldGroup.tags,
                  actionTags: fieldGroup.actionTags !== undefined ? fieldGroup.actionTags : [],
                  tagVisible: fieldGroup.tagVisible,
                  prefix: fieldGroup.prefix
                }

                if (Object.keys(newGroup.checkboxes).length === 2) newGroup.abQuestion = fieldGroup.abQuestion !== undefined ? fieldGroup.abQuestion : false

                dataGroups.push(newGroup)
              }
            }
          }
          tabsOrderModel = []
          tabsOrderId = []
        }
      }

      newData = Object.values(newData)

      for (let index = 0; index < newData.length; index++) {
        let newField = JSON.parse(JSON.stringify(newData[index]))

        if (newField.type === 'section' && newField.page === undefined && newField.tabOrder === undefined) {
          newField.page = JSON.parse(JSON.stringify(newData[index + 1].page))
          newField.tabOrder = JSON.parse(JSON.stringify(newData[index + 1].tabOrder))

          newData[index] = newField
        } else if (newField.type === 'checkbox-group') newData.splice(index, 1)
      }

      dataGroups.forEach(group => {
        let nameFields = Object.keys(group.checkboxes)

        if (newData.map(a => a.name).indexOf(group.name) !== -1) newData.splice(newData.map(a => a.name).indexOf(group.name), 1)

        nameFields.forEach(fieldName => {
          if (newData.map(a => a.fieldName).indexOf(fieldName) !== -1) newData.splice(newData.map(a => a.fieldName).indexOf(fieldName), 1)
        })
      })

      newData = newData.concat(dataGroups)

      // Order definitly

      let tmpFormatted = {}

      tmpFormatted = this.setOrderFields(newData)

      // Set Questionnaires db and render

      this.$store.commit('setQuestionnaireFields', tmpFormatted)

      this.$bus.emit('reloadQuestionnaire')
    },

    // ORDER FIELDS FOR PAGE AND TAB ORDER

    setOrderFields (objFields) {
      let questionnaireFields = []
      let tmpFormatted = {}

      for (let countPage = 1; countPage <= this.$store.state.totalPages; countPage++) {
        let pageFields = objFields.filter(function (c) {
          return Number(c.page) === countPage
        })

        pageFields.forEach((field, index) => {
          if (index + 1 < pageFields.length && field.tabOrder === pageFields[index + 1].tabOrder) pageFields[index + 1].tabOrder = field.tabOrder + 1
        })

        let tmpPageFields = []

        tmpPageFields = pageFields.sort((a, b) => (a.tabOrder > b.tabOrder) ? 1 : -1)

        questionnaireFields = questionnaireFields.concat(tmpPageFields)
      }

      questionnaireFields.forEach((field, index) => {
        tmpFormatted[index + '-' + Math.random().toString(36).split('.')[1]] = field
      })

      return tmpFormatted
    },

    // SET INFORMATION FOR FIELDS AND FIELD GROUPS

    setupData (newData, sortByTabOrder = false) {
      this.formattedData = {}

      const keys = Object.keys(newData)

      // IF THERE ISN'T INFORMATION HIDE SPINNER AND SHOW MESSAGE

      if (!keys.length) {
        this.isSpinner = false

        this.noRows = true
        return
      }

      let newGroup = null
      let dataGroups = []
      let fieldGroup = {}

      if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return

      fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']

      if (fieldGroup !== null && typeof fieldGroup !== 'undefined' && Object.keys(fieldGroup).length) {
        for (const key in this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups']) {
          newGroup = {}

          if (this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'].hasOwnProperty(key)) {
            const fieldGroup = this.$store.state.templates[this.$store.state.currentTemplateName]['checkboxGroups'][key]

            if (fieldGroup.hide !== true) {
              let groupModel = ''

              newGroup = {
                type: 'checkbox-group',
                fieldName: key,
                state: 'OK',
                originalValue: '',
                newValue: '',
                itemId: 23,
                model: groupModel,
                deleted: false,
                approved: true,
                editable: true,
                values: [],
                fieldAdd: fieldGroup.fieldAdd,
                name: fieldGroup.name,
                title: fieldGroup.title,
                desc: fieldGroup.desc,
                checkboxes: fieldGroup.fields,
                checked: fieldGroup.checked,
                maxChecked: fieldGroup.maxChecked,
                tabOrder: fieldGroup.tabOrder,
                page: fieldGroup.page,
                indent: fieldGroup.indent,
                tags: fieldGroup.tags,
                actionTags: fieldGroup.actionTags !== undefined ? fieldGroup.actionTags : [],
                tagVisible: fieldGroup.tagVisible,
                prefix: fieldGroup.prefix
              }

              if (fieldGroup.watchers) newGroup.watchers = fieldGroup.watchers

              if (
                newGroup.checkboxes &&
                Object.keys(newGroup.checkboxes).length === 2
              ) newGroup.abQuestion = fieldGroup.abQuestion !== undefined ? fieldGroup.abQuestion : false

              if (!newGroup.checkboxes) newGroup.checkboxes = {}

              dataGroups.push(newGroup)
            }
          }
        }
      }

      newData = []

      newData = Object.values(JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data)))

      for (let index = 0; index < newData.length; index++) {
        let newField = JSON.parse(JSON.stringify(newData[index]))

        // SET POSITION FOR SECTIONS

        if (newField.type === 'section' && newField.page === undefined && newField.tabOrder === undefined) {
          if (
            newData[index + 1] !== undefined &&
            newData[index + 1] !== null
          ) {
            if (
              newData[index + 1].page !== undefined &&
              newData[index + 1].page !== null
            ) newField.page = JSON.parse(JSON.stringify(newData[index + 1].page))

            if (
              newData[index + 1].tabOrder !== undefined &&
              newData[index + 1].tabOrder !== null
            ) newField.tabOrder = JSON.parse(JSON.stringify(newData[index + 1].tabOrder) - 1)
          }

          newData[index] = newField

          // IF THERE IS CREATED FIELD GROUPS, REMOVE THEM
        } else if (newField.type === 'checkbox-group') newData.splice(index, 1)
      }

      // SET EMPTY AB FIELDS WATCHERS

      this.$store.commit('resetAbFieldsWatcher')

      // SET FIELD GROUPS ON LIST INFORMATION

      dataGroups.forEach(group => {
        if (
          group.checkboxes &&
          Object.keys(group.checkboxes).length === 2 &&
          group.checkboxes[Object.keys(group.checkboxes)[0]].type === 'checkbox' &&
          group.checkboxes[Object.keys(group.checkboxes)[1]].type === 'checkbox'
        ) {
          this.$store.commit('setAbFieldWatcher', group.tags)
        }

        let nameFields = group.checkboxes ? Object.keys(group.checkboxes) : []

        if (newData.map(a => a.name).indexOf(group.name) !== -1) newData.splice(newData.map(a => a.name).indexOf(group.name), 1)

        nameFields.forEach(fieldName => {
          if (newData.map(a => a.fieldName).indexOf(fieldName) !== -1) newData.splice(newData.map(a => a.fieldName).indexOf(fieldName), 1)
        })
      })

      newData = newData.concat(dataGroups)

      // SET ORDER WITH PAGE FIELD AND TAB ORDER

      let tmpFormatted = {}

      tmpFormatted = this.setOrderFields(newData)

      // SET QUESTIONNAIRES ON DB AND RENDER LIST

      this.noRows = !Object.keys(tmpFormatted).length
      this.formattedData = {}
      this.formattedData = tmpFormatted
      this.$store.commit('setQuestionnaireFields', this.formattedData)

      this.updateQuestionnaire()
      this.isSpinner = false
    },

    // UPDTE LOCAL INFO WHEN DELETE FIELD OR FIELD GROUP

    setQuestionnairesFields () {
      this.formattedData = {}
      let questionnaireFields = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName]['data']))
      let keys = Object.keys(questionnaireFields)
      let newData = []
      if (keys.length > 0) newData = Object.values(questionnaireFields)

      let tmpFormatted = {}

      for (let index = 0; index < newData.length; index++) {
        let newField = JSON.parse(JSON.stringify(newData[index]))

        tmpFormatted[index + '-' + Math.random().toString(36).split('.')[1]] = newField
      }

      this.noRows = !Object.keys(tmpFormatted).length
      this.formattedData = Object.assign(this.formattedData, tmpFormatted)
    },

    // SHOW HIGHLIGHT FOR SELECTED FIELD

    setFieldPage (fieldData) {
      // MARK FIELDGROUP

      if (fieldData.type === 'checkbox-group') {
        let tmpPageFields = Object.values(fieldData.fields)

        tmpPageFields = tmpPageFields.sort((a, b) => (a.tabOrder > b.tabOrder) ? 1 : -1)

        fieldData.name = tmpPageFields[0].id
        fieldData.type = tmpPageFields[0].type
      }

      // MARK FIELD

      for (let contadorPage = 1; contadorPage <= Object.keys(this.$store.state.templates[this.$store.state.currentTemplateName]['pages']).length; contadorPage++) {
        for (let contadorField = 0; contadorField < (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage]).length; contadorField++) {
          if (this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField] === null) continue
          if ((this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].name) === fieldData.name) {
            let pageData = {
              name: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].name,
              fieldPage: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].fieldPage,
              type: this.$store.state.templates[this.$store.state.currentTemplateName]['pages'][contadorPage][contadorField].type
            }
            if (parseInt(pageData.fieldPage) === this.$store.state.fileCurrentPage) {
              const highlighted = document.querySelectorAll('.id-highlight')
              for (const highlight of highlighted) {
                highlight.classList.remove('id-highlight')
              }
              this.$bus.emit('hideTooltip')
              if (fieldData.type !== 'text') this.$bus.emit('scrollToElement', pageData.name)
              else document.getElementById(pageData.name).focus()
              this.$bus.emit('showTooltip', pageData.name)
              let dataField = this.$store.getters.getTemplateData(pageData.name)
              if (dataField.type !== 'text') {
                let targetEl = document.getElementById(dataField.name)
                if (targetEl === null) return
                targetEl.classList.add('id-highlight')
              }
            } else {
              this.$bus.emit('hideTooltip')
              this.$store.commit('setDisablePageNavigation', true)
              this.$store.commit('setCurrentPage', Math.floor(Number(pageData.fieldPage)))
              this.$bus.emit('pageChange', Math.floor(Number(pageData.fieldPage)))
              this.$bus.emit('showTooltip', pageData.name)
              this.$bus.emit('hidePageFields')
            }
          }
        }
      }
    },

    saveEdit (data) {
      let field = JSON.parse(JSON.stringify(this.formattedData[data.key]))
      let storeField = this.$store.getters.templateFieldById(field.fieldName)
      let fieldIndex = this.$store.getters.currentTemplateFieldIndex(storeField.id, storeField.fieldPage)
      this.$store.commit('setTemplateFieldQuestionText', {
        index: fieldIndex,
        page: storeField.fieldPage,
        title: data.data.title,
        helpText: data.data.desc
      })
      this.$store.dispatch('saveTemplate')

      let tmpFormatted = JSON.parse(JSON.stringify(this.formattedData))
      tmpFormatted[data.key] = data.data
      this.formattedData = tmpFormatted
      this.updateQuestionnaireStore()
      this.updateQuestionnaire()
    },

    updateQuestionnaireStore () {
      if (this.$store.state.currentTemplateName === 'global') return
      if (typeof this.$store.state.questionnaires[this.$store.state.currentTemplateName] === 'undefined') return

      let tmpQuestionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))
      let backFields = []

      Object.keys(tmpQuestionnaires[this.$store.state.currentTemplateName].data).forEach((fieldId, index) => {
        let foundWidget = this.$store.getters.modelWidget(tmpQuestionnaires[this.$store.state.currentTemplateName].data[fieldId].model)
        if (foundWidget !== null) backFields.push({name: this.$store.getters.modelWidget(tmpQuestionnaires[this.$store.state.currentTemplateName].data[fieldId].model), position: index})
      })

      tmpQuestionnaires[this.$store.state.currentTemplateName].data = this.formattedData
      this.$store.commit('setQuestionnaires', tmpQuestionnaires)
    },

    deleteField (fieldKey) {
      window.swal({
        title: 'Delete Questionnaire Field?',
        text: 'You are about to delete this questionnaire field. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          this.$store.commit('removeSection', fieldKey)
          this.setQuestionnairesFields()
          this.updateQuestionnaire()
        }
      })
    },

    deleteGroup (groupId) {
      window.swal({
        title: 'Delete Field Group?',
        text: 'You are about to delete this field group. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          this.$store.commit('removeFieldGroupFromQuestionnaire', groupId)
          this.setQuestionnairesFields()
          this.$store.dispatch('saveTemplate')
        }
      })
    },

    editGroup (fieldKey) {
      this.$bus.emit('fieldGroupEditModal', fieldKey)
    },
    getDataField (fieldKey) {
      let field = JSON.parse(JSON.stringify(this.formattedData[fieldKey]))
      let storeField = this.$store.getters.templateFieldById(field.fieldName)
      if (typeof storeField.questionTitle === 'undefined' || typeof storeField.questionHelp === 'undefined') {
        let fieldIndex = this.$store.getters.currentTemplateFieldIndex(storeField.id, storeField.fieldPage)
        this.$store.commit('setTemplateFieldQuestionText', {
          index: fieldIndex,
          page: storeField.fieldPage,
          title: storeField.id,
          helpText: ''
        })
        this.$store.dispatch('saveTemplate')
      }

      field['fieldDisplayName'] = storeField.name
      return field
    },

    editField (fieldKey) {
      let field = this.getDataField(fieldKey)
      this.$bus.emit('openFieldMenu', {
        id: field.fieldName,
        page: field.page
      })
    },

    editSection (fieldKey) {
      this.$bus.$emit('sectionEditModal', fieldKey)
    },

    deleteSection (sectionId) {
      window.swal({
        title: 'Delete Questionnaire Section?',
        text: 'You are about to delete this questionnaire section. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (deleted) {
          this.$store.commit('removeSection', sectionId)
          this.$bus.emit('reloadQuestionnaire')
        }
      })
    },

    move (moveIndex, up) {
      let fieldKeys = Object.keys(this.formattedData)

      let tmpFields = JSON.parse(JSON.stringify(this.formattedData))

      fieldKeys.forEach((key, index) => {
        if (key === moveIndex) {
          let tmpPage = tmpFields[moveIndex].page
          let tmpTabOrder = tmpFields[moveIndex].tabOrder
          let indexChange = index

          if (up === true && index > 0) indexChange--
          else indexChange++

          tmpFields[moveIndex].tabOrder = tmpFields[fieldKeys[indexChange]].tabOrder
          tmpFields[moveIndex].page = tmpFields[fieldKeys[indexChange]].page

          tmpFields[fieldKeys[indexChange]].tabOrder = tmpTabOrder
          tmpFields[fieldKeys[indexChange]].page = tmpPage

          // Save fieldGroups tab Order in template
          if (tmpFields[moveIndex].name !== undefined) {
            this.$store.commit('editFieldGroup', {
              index: tmpFields[moveIndex].fieldName,
              name: tmpFields[moveIndex].name,
              label: tmpFields[moveIndex].title,
              help: tmpFields[moveIndex].desc,
              tabOrder: tmpFields[moveIndex].tabOrder,
              prefix: tmpFields[moveIndex].prefix,
              page: tmpFields[moveIndex].page
            })
          }

          if (tmpFields[fieldKeys[indexChange]].name !== undefined) {
            this.$store.commit('editFieldGroup', {
              index: tmpFields[fieldKeys[indexChange]].fieldName,
              name: tmpFields[fieldKeys[indexChange]].name,
              label: tmpFields[fieldKeys[indexChange]].title,
              help: tmpFields[fieldKeys[indexChange]].desc,
              tabOrder: tmpFields[fieldKeys[indexChange]].tabOrder,
              prefix: tmpFields[fieldKeys[indexChange]].prefix,
              page: tmpFields[moveIndex].page
            })
          }
        }
      })

      this.$store.dispatch('saveTemplate')

      let orderFields = []

      orderFields = Object.values(tmpFields)

      this.formattedData = {}

      this.formattedData = this.setOrderFields(orderFields)

      this.$store.commit('setQuestionnaireFields', this.formattedData)
      this.updateQuestionnaire()
    },

    widgetChanged (data) {
      let tmpFormatted = JSON.parse(JSON.stringify(this.formattedData))
      if (this.formattedData[data.index].type === 'grid') {
        tmpFormatted[data.index].data = data.value
      } else tmpFormatted[data.index].newValue = data.value
      this.formattedData = tmpFormatted
      this.updateQuestionnaireStore()
      this.updateQuestionnaire()
    },

    scrollToElement (fieldName) {
      let el = document.querySelector('[data-field="' + fieldName + '"')
      if (el === null) {
        let nameWidget = this.$store.getters.getIdWidgetGroup(fieldName)
        let nameFieldGroup = this.$store.getters.fieldGroup(fieldName)
        if (nameWidget !== null) fieldName = nameWidget
        if (nameFieldGroup !== null) fieldName = nameFieldGroup
        el = document.querySelector('[data-field="' + fieldName + '"')
      }
      if (el === null) return
      this.$store.commit('setSelectedQuestionnaireField', fieldName)
      for (const activeEl of document.querySelectorAll('.active-widget')) {
        activeEl.classList.remove('active-widget')
      }
      if (fieldName !== this.lastHighlightedModel) {
        el.parentElement.classList.add('active-widget')
        el.scrollIntoView({block: 'center', behavior: 'smooth'})
        this.lastHighlightedModel = fieldName
      } else this.lastHighlightedModel = ''
    },

    toggleModelDisplay () {
      this.modelDisplay = !this.modelDisplay
      this.$bus.emit('toggleModelDisplay', this.modelDisplay)
    },

    toggleIdDisplay () {
      this.idDisplay = !this.idDisplay
      this.$bus.emit('toggleIdDisplay', this.idDisplay)
    },

    updateQuestionnaire () {
      const apiUrl = this.$store.state.apiUrl

      if (
        !this.$store.state.questionnaires[this.$store.state.currentTemplateName] ||
        this.$store.state.questionnaires[this.$store.state.currentTemplateName] === null
      ) return

      let currentQuestionnaire = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName]))

      let newFields = []
      for (const field of Object.values(currentQuestionnaire.data)) {
        let newField = JSON.parse(JSON.stringify(field))
        newFields.push(newField)
      }
      currentQuestionnaire['data'] = newFields

      const requestData = {
        questionnaireId: currentQuestionnaire._id,
        newData: currentQuestionnaire
      }
      let that = this
      this.axios.post(apiUrl + 'questionnaire/update', requestData).then(response => {
        that.$store.commit('setLastSaved', Date.now())
      })
    },

    initialUpdate () {
      let newData = {}
      if (typeof this.$store.state.questionnaires[this.$store.state.currentTemplateName] !== 'undefined') {
        newData = JSON.parse(JSON.stringify(this.$store.state.questionnaires[this.$store.state.currentTemplateName].data))
      }
      newData.generate = true
      this.setupData(newData, true)
    },

    generateFields () {
      this.loading = true
      window.swal({
        title: 'Generate Questions?',
        text: 'You are about to generate questionnaire questions using the form fields. This will replace your current questionnaire data. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((generate) => {
        if (generate) {
          let existingModels = []
          let newQuestionnaireData = []
          let currentTemplateName = this.$store.state.currentTemplateName
          if (this.$store.state.templates[this.$store.state.currentTemplateName] === undefined) return
          for (const pageIndex in this.$store.state.templates[currentTemplateName]['pages']) {
            if (this.$store.state.templates[currentTemplateName]['pages'].hasOwnProperty(pageIndex)) {
              const page = this.$store.state.templates[currentTemplateName]['pages'][pageIndex]
              if (page === null) continue
              page.forEach(field => {
                if (field === null) {
                  return
                } else {
                  if (field.model === null || field.model === undefined) field.model = ''
                  if (field.model.length && existingModels.indexOf(field.model) !== -1) return
                  let prefix = ''
                  if (field.prefix) prefix = field.prefix
                  let newField = {
                    type: field.type,
                    fieldName: field.id,
                    state: 'OK',
                    originalValue: typeof field.value !== 'undefined' && field.value.length ? field.value : '',
                    newValue: '',
                    itemId: 23,
                    model: field.model,
                    prefix: prefix,
                    deleted: false,
                    approved: true,
                    editable: true,
                    values: [],
                    title: field.id,
                    desc: '',
                    tabOrder: field.tabOrder,
                    page: pageIndex,
                    render: true,
                    tags: field.tags,
                    maxCharacter: Number(field.maxCharacter)
                  }

                  if (field.forceShow !== undefined) {
                    newField.forceShow = field.forceShow
                  }

                  if (typeof field.translations !== 'undefined') {
                    if (typeof field.translations[this.$store.state.currentLocale] !== 'undefined') {
                      newField.title = field.translations[this.$store.state.currentLocale]['label']
                      newField.desc = field.translations[this.$store.state.currentLocale]['text']
                    }
                  }

                  if (newField.type === 'textarea') newField.type = 'text'
                  else if (newField.type === 'radio') newField.type = 'checkbox'
                  else if (newField.type === 'button') newField.type = 'checkbox'
                  else if (newField.type === 'select') {
                    newField.type = 'combobox'
                    newField.values = field.choiceData
                  }
                  existingModels.push(field.model)
                  if (field.model === '' || field.forceShow === true) newQuestionnaireData.push(newField)
                }
              })
            }
          }

          let tmpQuestionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))
          if (typeof tmpQuestionnaires[currentTemplateName] === 'undefined') {
            tmpQuestionnaires[currentTemplateName] = {
              templateId: this.$store.state.templates[this.$store.state.currentTemplateName]['_id'],
              data: newQuestionnaireData
            }
          } else {
            tmpQuestionnaires[currentTemplateName].data = newQuestionnaireData
          }
          tmpQuestionnaires[currentTemplateName].data = tmpQuestionnaires[this.$store.state.currentTemplateName].data
          this.$store.commit('setQuestionnaires', tmpQuestionnaires)
          this.initialUpdate()
        } else {
          this.loading = false
        }
      })
    },

    removeAll () {
      this.loading = false
      window.swal({
        title: 'Remove Questions?',
        text: 'You are about to remove all of the current questionnaire fields. This action cannot be undone. Are you sure you want to continue?',
        icon: 'warning',
        buttons: true,
        dangerMode: true
      }).then((deleted) => {
        if (!deleted) return
        let tmpQuestionnaires = JSON.parse(JSON.stringify(this.$store.state.questionnaires))
        tmpQuestionnaires[this.$store.state.currentTemplateName].data = []
        this.$store.commit('setQuestionnaires', tmpQuestionnaires)
        let tmpTemplates = JSON.parse(JSON.stringify(this.$store.state.templates))
        this.$store.commit('setTemplates', tmpTemplates)
        this.$store.dispatch('saveTemplate')
        this.formattedData = {}
        this.templateChanged(this.$store.state.currentTemplateName)
        this.updateQuestionnaire()
      })
    },

    noDataFound () {
      if (this.formattedData === null || this.formattedData === undefined) {
        this.isSpinner = false
        this.formattedData = {}
        this.loading = true
      }
    }
  },

  beforeDestroy () {
    this.$off('widgetChanged')
    this.$off('saveEdit')
    this.$bus.$off('scrollToElement')
    this.$bus.$off('setCurrentTemplateName')
    this.$bus.$off('reloadQuestionnaire')
    this.$bus.$off('updateQuestionnaire')
    this.$bus.$off('setOnlyFieldGroup')
    this.$bus.$off('initialUpdate')
    this.$bus.$off('setFieldPage')
    this.$bus.$off('pageChange')
    this.$bus.$off('removeSection')
  }
}
</script>

<style lang="scss" scoped>
  .bar-icons{
    position: fixed;
    width: 49%;
    background-color: #e5e4e4;
    box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
    margin-left: 58px;
    right: 1%;
    padding-bottom: 10px;
    z-index: 3;
    top: 0;
    padding-left: 6px;
    background-color: #ececec;
    box-shadow: 1px 2px 8px -3px rgba(0, 0, 0, 0.8);
  }
  .icons-individual{
    display: inline;
    margin-right: -6px;
  }
  .mybutton{
    background-color: white;
    margin: 10px 3px 0px 4px;
    // border: 1px solid black;
    font-size: .830rem;
    border: 1px solid rgba(0, 0, 0, 0.46);
    border-radius: 0.25rem;
  }
  .mybutton:hover{
      background-color: lightgray;
  }
  .colorIcon01 {
    color: #00e4ff;
  }
  .colorIcon02 {
    color: #05e0c3;
  }
  .backgroundIcon {
    background-color: #05e0c3;
  }
  .questionnaire {
    /* right: 25%;
    transform: translateX(34%); */
    height: calc(100vh - 64px);
    width: 47%;
    margin-left: 1.5%;
    right: 20px;
    // border: 1px solid black;
    // overflow-x: hidden;
    // box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
  }



  #questionnaireView {
    padding: 5px;
  }

  #questionnaireBody {
    width: 100%;
    height: calc(100% - 50px);
  }

  #questionnaireControls {
    position: fixed;
    float: right;
    top: 0;
    right: 0;
    // background-color: #FFF;
    background-color: #2D5F8B;
    width: 50%;
    height: 50px;
    // border-bottom: 2px solid black;
    // padding-top: 4%;
    // padding-left: 1%;
    padding: 10px;
    z-index: 1;
    text-align: center;

    button {
      width: auto;
      transition: .3s;
      &:hover {
        background-color: #333;
        color: white;
        transition: .3s;
      }
    }
  }

  
  .widget-sort {
    position: absolute;
    right: 23px;
    bottom: 15px;
    font-size: 14px;
    i {
      display: inline;
      font-size: 1.5em;
      font-weight: bold;
      margin-left: 10px;
      cursor: pointer;

      &:hover {
        color: #2D5F8B;
      }
    }
  }

  .active-widget {
    // position: absolute;
    outline: 4px dashed green;
    // border-color: green;
    // border-width: 1px;
    // border-style: solid;
    border-radius: 10px;
    
  }

  .widget-row {
    box-shadow: 5px 4px 9px -3px rgba(0,0,0,0.8);
    margin-top: 20px;
    border-radius: 10px;
    padding: 20px;
  }

  .widget-label {
    font-weight: bold;
    margin-top: -5px;
    margin-bottom: 5px;
  }

  .input-subtext {
    color: #777;
    margin-top: 5px;
    margin-bottom: 10px;
  }

  .single-widget {
    position: relative;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-left: 30px;
    padding-top: 19px;
    border: 1px solid black;
    border: 2px solid rgba(0, 0, 0, 0.19);
    border-radius: 0.25rem;
    box-shadow: 1px 2px 8px -4px rgba(0, 0, 0, 0.8);
    overflow: auto;
  }

  .group-box {
    position: relative;
    margin-top: 20px;
    margin-bottom: 20px;
    padding-bottom: 40px;
    border: 1px solid black;
  }

  .fa-edit, .fa-trash {
    cursor: pointer;
  }

  button.classic {
    margin-top: 8px;
  }
  button.classic:hover {
    background-color: rgb(199, 199, 199);
  }

.indent-level1 {
  margin-left: 5%
}

.indent-level2 {
  margin-left: 10%
}

.indent-level3 {
  margin-left: 15%
}
</style>



// WEBPACK FOOTER //
// src/views/QuestionnaireView.vue